import * as ActionTypes from "../ActionTypes.js";
import { toast } from "react-toastify";
import { getServerDomain, toastOptions } from "utils";

export const getUsers = (dispatch) => {
  return fetch(getServerDomain() + "/users", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) =>
      dispatch({ type: ActionTypes.GET_USERS, payload: response })
    )
    .catch((error) => {
      console.log("Get users ", error.message);
      toast.error("Could not fetch users" + error.message, toastOptions);
    });
};
